import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useRouter } from '~/utils/navigation';
import { setPostAuthLocation } from '~/components/authentication/ducks/index';
import { generatePostAuthLocation } from '~/components/authentication/index';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';
import { ROUTE_GUEST_DEPOSIT_LOGIN, ROUTE_LOGIN_GUEST } from '~/components/router/constants';
import { isSmallerSelector } from '~/components/layout/mediaquery';
import { selectDefaultProduct } from '~/components/brand/ducks/selectors';
import useBasePathname from '~/hooks/use-base-pathname';

const useGuestLogin = () => {
	const dispatch = useDispatch();
	const router = useRouter();
	const transformPath = useContextualPathTransformer();
	const smaller = useSelector(isSmallerSelector);
	const defaultProduct = useSelector(selectDefaultProduct);
	const basePathname = useBasePathname(defaultProduct);
	const location = useLocation();

	const redirectToGuestLogin = useCallback(
		(gameUrl: string | null) => {
			const postAuthLocation: string =
				gameUrl ?? (generatePostAuthLocation(location, smaller, transformPath, basePathname) as string);
			dispatch(setPostAuthLocation(postAuthLocation));
			router.push(transformPath(ROUTE_GUEST_DEPOSIT_LOGIN));
		},
		[location, smaller, transformPath, basePathname, dispatch, router]
	);

	const redirectToPlayAsGuest = useCallback(() => {
		router.push(transformPath(ROUTE_LOGIN_GUEST));
	}, [router, transformPath]);

	return {
		redirectToGuestLogin,
		redirectToPlayAsGuest
	};
};

export default useGuestLogin;
